// PageProjectViewTeam Component

/* eslint react/jsx-closing-bracket-location: 0,
  standard/no-callback-literal: 0,
  react/jsx-handler-names: 0 */

import React from 'react'
import _ from 'lodash'

import app from '../../../app.jsx'
import ContentMessage from '../../../common/common/content_message/content_message.jsx'
import Grid from '../../../common/common/grid/grid.jsx'
import ProjectTeamItem from '../../project/project_teamitem/project_teamitem.jsx'
import DialogProjectTeamAdd from '../../dialog/dialog_project_teamadd/dialog_project_teamadd.jsx'
import BaseProjectView from '../../page/base_projectview/base_projectview.jsx'

class PageProjectViewTeam extends BaseProjectView {
  constructor (props) {
    super(props, 'projectview-team', 'project', 'projectview-team', 'team')

    this.state = {
      loading: true
    }

    this.data = {
      project: this._getProjectFromCache(this.props.projectId),
      projectUsers: [],
      total: 0,
      countLoaded: 0,
      canPaginate: true,
      pageNo: 1,
      stat: this._getOverviewStatFromCache(this.props.projectId)
    }

    this._references = {
      dialogadd: React.createRef()
    }
    this.createCommonReference(this._references)

    this._setFABButtonState(true, false)
    this._bUnMounted = false
  }

  componentDidMount () {
    this._getData(false)
    this._initProjectCommonEvents()
  }

  componentWillUnmount () {
    this._bUnMounted = true
    this._releaseProjectCommonEvents()
  }

  renderContent () {
    return (
      <div className='page-projectviewteam'>
        {this._renderMessage()}
        {this._renderGrid()}
        <DialogProjectTeamAdd
          ref={this._references.dialogadd}
          onSearch={this._onSearchUser.bind(this)}
          onAdd={this._onCreateProjectUser.bind(this)}
        />
      </div>
    )
  }

  getContentClassname () {
    return 'alt'
  }

  /* Event Handlers */
  _onDeleteUser (user) {
    if (!user.id) {
      return false
    }

    app
      .service('/api/projectuser')
      .remove(user.id, {})
      .then(() => {
        this.data.pageNo = 1
        this._reloadData()
      })
      .catch(err => {
        app.debug('PageProjectViewTeam: _onDeleteUser err', err)
      })
  }

  _onChangePM = user => {
    // Set the projectManagerId, projectManagerName from user and save it
    const { project } = this.data

    const saveObj = {
      projectManagerId: user.userId,
      projectManagerName: user.displayName
    }

    app
      .service('/api/project')
      .patch(project.id, saveObj)
      .then(_res => {
        app.debug('PageProjectViewTeam: _onChangePM Done')
        this._reloadData()
      })
      .catch(err => {
        app.debug('PageProjectViewTeam: _onChangePM err', err)
      })
  }

  _onRemovePM = () => {
    const { project } = this.data

    const saveObj = {
      projectManagerId: '',
      projectManagerName: ''
    }

    app
      .service('/api/project')
      .patch(project.id, saveObj)
      .then(_res => {
        app.debug('PageProjectViewTeam: _onRemovePM Done')
        this._reloadData()
      })
      .catch(err => {
        app.debug('PageProjectViewTeam: _onRemovePM err', err)
      })
  }

  onAdd () {
    if (this._references.dialogadd.current) {
      this._references.dialogadd.current.show()
    }
  }

  _onSearchUser (keyword, callback) {
    const teamId = app.getTeamId()
    if (!keyword) {
      callback([])
      return
    }

    const pattern = keyword
      .replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
      .replace(/\$/g, '$$$$')
    const params = {
      query: {
        $select: ['userId', 'firstName', 'lastName', 'image'],
        $limit: 15,
        $or: [
          { firstName: { $regex: pattern, $options: 'i' } },
          { lastName: { $regex: pattern, $options: 'i' } }
        ],
        status: 'active'
      }
    }
    params.query.teamId = teamId

    app
      .service('/api/users/team')
      .find(params)
      .then(result => {
        const serachOptions = []
        result.data.map(user => {
          // If not existing
          if (
            _.findIndex(
              this.data.projectUsers,
              pUsr => pUsr.userId === user.userId
            ) < 0
          ) {
            serachOptions.push({
              label: user.displayName,
              value: user.userId,
              imageUrl: user.imageUrl
            })
          }
        })
        callback(serachOptions)
      })
      .catch(err => {
        app.debug('PageProjectViewTeam: _onSearchUser err', err)
        callback([])
      })
  }

  _onCreateProjectUser (userId) {
    const userObj = {
      userId: userId,
      projectId: this.props.projectId
    }

    app
      .service('/api/projectuser')
      .create(userObj)
      .then(() => {
        this.data.pageNo = 1
        this._reloadData()
      })
      .catch(err => {
        app.debug('PageProjectViewTeam: _onCreateProjectUser err', err)
      })
  }

  _getData (bReload) {
    app.debug('PageProjectViewTeam: _getDataProjectUsers [start]')
    const skip = (this.data.pageNo - 1) * 15

    const params = {
      query: {
        bUpdatePageState: bReload,
        pageIdent: this._pageIdent,
        projectId: this.props.projectId,
        project: {
          $client: {
            subObjects: {
              contact: ['company', 'rateCards', 'rateMarkup', 'rate']
            }
          }
        },
        projectTeamUser: {
          projectId: this.props.projectId,
          $limit: 15,
          $skip: skip,
          $sort: {},
          $client: {
            userDetail: true
          }
        }
      }
    }

    app
      .service('/api/page/project/team')
      .find(params)
      .then(result => {
        if (result) {
          this._onPageDataRecieved(result.pageData)

          if (result.project) {
            this.data.project = result.project
            this._setProjectToCache(this.data.project)
          }

          if (result.projectTeamUser) {
            this.data.projectUsers =
              this.data.pageNo > 1
                ? this.data.projectUsers.concat(result.projectTeamUser)
                : result.projectTeamUser
            this.data.total = result.totalProjectTeamUser
            this.data.countLoaded =
              params.query.projectTeamUser.$limit * this.data.pageNo
            this.data.canPaginate = !(this.data.countLoaded > this.data.total)
          }

          if (result.stat) {
            this.data.stat = result.stat
            this._setOverviewStatToCache(this.data.stat)
          }

          this._onDataReceived(null)
        }
      })
      .catch(err => {
        this._onDataReceived(err)
        app.debug('PageProjectTeam: _getData Error', err)
      })
  }

  /* _getDataProjectUsers(callback) {
    app.debug('PageProjectViewTeam: _getDataProjectUsers [start]');
    const skip = (this.data.pageNo - 1) * 15;
    const params = {
      query: {
        $limit: 15,
        $skip: skip,
        $sort: { },
        $client: { userDetail: true },
        projectId: this.props.projectId
      }
    };

    app.service('/api/projectuser').find(params).then((result) => {
      this.data.projectUsers = result.data;
      this.data.total = result.total;
      this.data.countLoaded = params.query.$limit * this.data.pageNo;
      this.data.canPaginate = !(this.data.countLoaded > this.data.total);

      callback(null);
    }).catch((err) => {
      app.debug('PageProjectViewTeam: _getDataProjectUsers err', err);
      callback(err);
    });
  } */

  _onDataReceived (err) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PageProjectViewTeam: _onDataReceived Error', err)
      this._setFABButtonVisible(false)
      this.setState({ loading: true, dataDate: new Date() })
    } else {
      app.debug('PageProjectViewTeam: _onDataReceived [done]')

      if (
        this.data.project.status !== 'closed' &&
        this.data.projectUsers &&
        this.data.projectUsers.length > 0
      ) {
        this._setFABButtonVisible(true)
      } else {
        this._setFABButtonVisible(false)
      }
      this.setState({
        loading: this.data.projectUsers && !this.data.projectUsers.length > 0,
        dataDate: new Date()
      })

      app.updatePageTitle(
        'projectview-team',
        this.data.project ? this.data.project.title : ''
      )
    }
  }

  _onPaginate () {
    if (this.data.canPaginate) {
      const page = this.data.pageNo + 1
      this.data.pageNo = page
      this._reloadData()
    }
  }

  _reloadData () {
    this._getData(true)
  }

  _renderGrid () {
    return (
      <div className='gridwrap'>
        <Grid
          objectList={this.data.projectUsers}
          sortOptions={null}
          onPaginate={this._onPaginate.bind(this)}
          sort={null}
          sortAsc={null}
          onRenderGrid={this._onRenderGrid.bind(this)}
        />
      </div>
    )
  }

  _onRenderGrid (user) {
    const projectSetting = app.projectSetting

    if (user && user.imageUrl && user.displayName) {
      const showDelete = this.data.project.status !== 'closed'

      return (
        <ProjectTeamItem
          user={user}
          isProjectManager={this.data.project.projectManagerId === user.userId}
          isProjectManagerStatus={projectSetting.isPmVisible}
          key={user.id}
          onDelete={this._onDeleteUser.bind(this, user)}
          showDelete={showDelete}
          totalUsers={
            this.data.projectUsers ? this.data.projectUsers.length : 0
          }
          onChangePM={this._onChangePM}
          onRemovePM={this._onRemovePM}
        />
      )
    }

    return null
  }

  _renderMessage () {
    if (this.state.loading) {
      return (
        <ContentMessage
          message='project.view.teamTitle'
          info='project.view.addTeamInfo'
          showAdd
          onAdd={this.onAdd.bind(this)}
        />
      )
    }

    return ''
  }
}

export default PageProjectViewTeam
